import { render, staticRenderFns } from "./ParentTable.vue?vue&type=template&id=69b557f3&scoped=true&"
import script from "./ParentTable.vue?vue&type=script&lang=js&"
export * from "./ParentTable.vue?vue&type=script&lang=js&"
import style0 from "./ParentTable.vue?vue&type=style&index=0&id=69b557f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b557f3",
  null
  
)

export default component.exports